import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

import { SettingsContext, UserContext } from '../../../contexts';
import { productApi } from '../../../product/services';

import ProductPreviewView from './ProductPreviewView';

const ProductPreview = ({
  renderedForId, // The product for which this preview was rendered. Can be null.
  onSelect,
  inModal = true,
}) => {
  const settings = useContext(SettingsContext);
  const { user } = useContext(UserContext);
  const [product, setProduct] = useState(null);
  const [requestType, setRequestType] = useState(null);
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    const params = new URLSearchParams(
      location.search || location.pathname.split('?')[1]
    );

    setRequestType(params.get('requestType'));

    const id = params.get('preview') || match?.params?.viewProductId;

    if (id && id !== product?.id) {
      productApi.getOne(id, setProduct);
    } else if (!id) {
      setProduct(null);
    }
  }, [location]);

  const onClose = () => {
    history.push(history.location.pathname.split('?preview')[0]);
  };

  const onProductRefresh = () => {
    if (product?.id) {
      productApi.getOne(product.id, setProduct);
    }
  };

  const onSelectDefault = inModal ?
    (product) => history.push(`/request/new?product_id=${product.id}&${settings.iframeQueryParams}`) :
    undefined; // Do nothing

  return (
    <ProductPreviewView
      {...{
        renderedForId,
        user,
        product,
        inModal,
        onClose,
        onSelect: onSelect || onSelectDefault,
        requestType,
        onProductRefresh,
      }}
    />
  );
}

export default ProductPreview;
